import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { MassMessagesState } from './types';

const massMessagesSlice = createSlice({
  name: 'mass-messages',
  initialState: {
    searchTerm: '',
    totalAmount: 0,
  } as MassMessagesState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setTotalAmount: (state, action: PayloadAction<number>) => {
      state.totalAmount = action.payload;
    },
  },
});

export const { setSearchTerm, setTotalAmount } = massMessagesSlice.actions;
export default massMessagesSlice.reducer;
